

















import { Component } from "vue-property-decorator";
import { ssoEndpoints, images } from "@/core/constants";
import AppVue from "@/AppVue.vue";

@Component
export default class LoginView extends AppVue {
  get baseApiUrl() {
    return process.env.VUE_APP_WEBAPI_URL;
  }

  get dovetailLoginUrl() {
    return ssoEndpoints.dovetailLogin;
  }

  get imiLoginUrl() {
    return ssoEndpoints.imiLogin;
  }

  get eiLoginUrl() {
    return ssoEndpoints.eiLogin;
  }

  get userLoginUrl() {
    return ssoEndpoints.userLogin;
  }

  get eiLogo() {
    return images.eiLogo;
  }

  get imiLogo() {
    return images.imiLogo;
  }

  get spotlight() {
    return images.spotlight;
  }
}
